import { useContext, useMemo, useState } from 'react'

import { DATE_FNS_LOCALE } from '@hhgtech/hhg-components/constants'
import { Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps, Tabs } from '@mantine/core'
import { format } from 'date-fns'

import { useRouterExtend } from 'hooks/useRouterExtend'
import { ScheduleEventCard } from 'interfaces/types'

import useStyles from './index.styles'
import { ScheduleEventContext } from '../../../context'
import { EventCard } from '../../../eventCard'
import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { checkIsCurrentMonth } from '../../../utils'
import dayjs from 'dayjs'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { CarouselOrListingBlock } from 'components/molecules/carouselOrListingBlock'
import flatten from 'lodash/flatten'
import { Embla } from '@mantine/carousel'

type Props = {
  groupByMothList: {
    monthArr: string[]
    monthLength: number
    listing: { [key in string]: ScheduleEventCard[] }
  }
} & BoxProps

const MAX_DISPLAY_MONTH = 3

export const MobileLayout = ({
  groupByMothList,
  styles,
  classNames,
  className,
}: Props) => {
  const { wrapperProps } = useContext(ScheduleEventContext)
  const { locale } = useRouterExtend()
  const { classes, cx } = useStyles(undefined, {
    name: 'ScheduleEvent__EventList-GroupByStatus--Desktop',
    styles,
    classNames,
  })
  const [activeTab, setActiveTab] = useState<string | null>(
    groupByMothList.monthArr[0],
  )
  const [embla, setEmbla] = useState<Embla | null>(null)
  const currentUrl = useCurrentUrl()
  const formatedList = useMemo(() => {
    const monthList = groupByMothList.monthArr.slice(0, MAX_DISPLAY_MONTH)
    let lastIndex = 0
    const indexOfMonth: { [key: string]: number } = {}
    const listing = flatten(
      monthList.map((month, idx) => {
        indexOfMonth[month] = idx + lastIndex
        const curList = groupByMothList.listing[month] || []
        lastIndex = lastIndex + curList.length - 1
        return curList
      }),
    )
    return {
      monthList,
      listing,
      indexOfMonth,
    }
  }, [groupByMothList])
  console.log({ formatedList })
  return (
    <Box className={cx(className, classes.root)}>
      <Box className={classes.info}>
        <Text size="h2">{wrapperProps.title}</Text>
        <Text size="p3">{wrapperProps.description}</Text>
      </Box>
      <Box className={classes.body}>
        <Box className={classes.bodyInner}>
          <Tabs
            classNames={{ tab: classes.monthItem }}
            value={activeTab}
            keepMounted
            onTabChange={(v) => {
              setActiveTab(v)
              v && embla?.scrollTo(formatedList.indexOfMonth[v])
              v && console.log({ v, index: formatedList.indexOfMonth[v] })
            }}
            styles={{
              root: {
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                gap: 24,
              },
              tabsList: {
                borderBottom: 0,
              },
              tab: {
                '&[data-active],&:focus': {
                  borderColor: 'transparent',
                  outline: 0,
                },
              },
              panel: {
                display: 'block !important',
                transition: 'opacity 0.2s ease',
                '&.inactive': {
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  opacity: 0,
                  zIndex: 0,
                },
                '&.active': {
                  position: 'relative',
                  zIndex: 1,
                },
              },
            }}
          >
            <Tabs.List>
              <Box className={classes.monthGroup}>
                <img
                  src={CommonGAssets.getAssetPath('tiki/calendar-bar.png')}
                  className={classes.calendarImg}
                  alt={'calendar'}
                  loading="lazy"
                />
                <Box className={classes.monthList}>
                  {formatedList.monthList.map((month, idx) => {
                    const title = format(
                      new Date(2020, dayjs(month, 'MM-YYYY').month(), 1),
                      'MMMM',
                      {
                        locale:
                          DATE_FNS_LOCALE[
                            locale as keyof typeof DATE_FNS_LOCALE
                          ],
                      },
                    )
                    return (
                      <Tabs.Tab
                        value={month}
                        key={idx}
                        className={cx(
                          checkIsCurrentMonth(month) ? 'active' : '',
                          classes.monthItem,
                        )}
                        data-event-category="Service Connection"
                        data-event-action={`Livestream Schedule - ${title}`}
                        data-event-label={currentUrl}
                      >
                        <Text size="s1" className="text">
                          {title}
                        </Text>
                      </Tabs.Tab>
                    )
                  })}
                </Box>
              </Box>
            </Tabs.List>
            <Box sx={{ position: 'relative' }}>
              <Box className={cx(classes.group)}>
                <CarouselOrListingBlock
                  percentOfEndSlideMobile={85}
                  onSlideChange={(idx) =>
                    setActiveTab(formatedList.listing[idx]?.monthKey || null)
                  }
                  carouselSetting={{
                    getEmblaApi: setEmbla,
                  }}
                >
                  <CarouselOrListingBlock.Slider
                    styles={() => ({
                      progressRoot: {
                        display: 'none',
                      },
                    })}
                  >
                    {formatedList.listing.map((i, idx) => (
                      <EventCard
                        item={i}
                        classNames={{
                          root: classes.card,
                        }}
                        key={idx}
                      />
                    ))}
                  </CarouselOrListingBlock.Slider>
                </CarouselOrListingBlock>
                <Box className={classes.listing}></Box>
              </Box>
            </Box>
          </Tabs>
        </Box>
      </Box>
    </Box>
  )
}
